import { render, staticRenderFns } from "./private-rooms.vue?vue&type=template&id=6bdda5d4&scoped=true"
import script from "./private-rooms.vue?vue&type=script&lang=js"
export * from "./private-rooms.vue?vue&type=script&lang=js"
import style0 from "./private-rooms.vue?vue&type=style&index=0&id=6bdda5d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdda5d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bdda5d4')) {
      api.createRecord('6bdda5d4', component.options)
    } else {
      api.reload('6bdda5d4', component.options)
    }
    module.hot.accept("./private-rooms.vue?vue&type=template&id=6bdda5d4&scoped=true", function () {
      api.rerender('6bdda5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/challenge-friends/views/private-rooms.vue"
export default component.exports